
const escolaridades = [
    "Seleccione una opción",
    "Preparatoria",
    "Licenciatura",
    "Maestría",
    "Doctorado"
]

const meses = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
];

const archivos_necesarios = [
    {
        nombre: 'cv',
        descripcion: 'CV',
        mostrar: true
    },
    {
        nombre: 'rfc',
        descripcion: 'RFC (Constancia de situación fiscal actual)',
        mostrar: true
    },
    {
        nombre: 'nss',
        descripcion: 'NSS Número de Seguridad social (hoja del IMSS)',
        mostrar: true
    },
    {
        nombre: 'ine',
        descripcion: 'INE (Vigente)',
        mostrar: true
    },
    {
        nombre: 'curp',
        descripcion: 'CURP',
        mostrar: true
    },
    {
        nombre: 'acta_de_nacimiento',
        descripcion: 'Acta de nacimiento',
        mostrar: true
    },
    {
        nombre: 'comprobante_de_domicilio',
        descripcion: 'Comprobante de domicilio (No mayor a 3 meses)',
        mostrar: true
    },
    {
        nombre: 'constancia_de_no_inhabilitación',
        descripcion: 'Constancia de no inhabilitación',
        mostrar: true
    },
    {
        nombre: 'cartas_de_recomendacion',
        descripcion: '2 Cartas de recomendación preferentemente donde prestó sus servicios',
        mostrar: true
    },
    {
        nombre: 'carta_de_antecedentes_no_penales',
        descripcion: 'Carta de antecedentes no penales',
        mostrar: true
    },
    {
        nombre: 'anexos',
        descripcion: 'Anexos (Constancias laborales y diplomas)',
        mostrar: true
    },{
        nombre: 'cuenta_bancaria',
        descripcion: 'Estado de cuenta o captura con número de cuenta cuenta BBVA',
        mostrar: false
    }
];


export {
    escolaridades, meses, archivos_necesarios
}
